import React from 'react';
import { observer } from 'mobx-react';
import { useTranslation } from 'react-i18next';
import styled from 'styled-components';

import Insights from '@/comp/pages/ValueDashboardPage/Insights/Insights';

const InsightsReportPage = observer(() => {
  const { t } = useTranslation();

  const description = (
    <div>
      <p>{t('insightsReportDescriptionOne')}</p>
      <p>{t('insightsReportDescriptionTwo')}</p>
      <p>{t('insightsReportDescriptionThree')}</p>
    </div>
  );

  return (
    <Container>
      <Insights className="card-item" description={description} animation={false} />
    </Container>
  );
});

const Container = styled.div`
  .insights-card-wrapper {
    width: 620px;
    margin: ${({ theme: { token } }) => token.marginXXL}px auto ${({ theme: { token } }) => token.marginXXL}px;
  }

  .description {
    p {
      margin-bottom: ${({ theme: { token } }) => token.marginMD}px !important;
    }
  }
`;

export default InsightsReportPage;
